import React, { Component } from "react";
import "./index.css";

class Header extends Component {
  shouldComponentUpdate(prevProps) {
    const { isLarge, backgroundImage, backgroundPosition } = this.props;
    return (
      prevProps.backgroundImage !== backgroundImage ||
      prevProps.backgroundPosition !== backgroundPosition ||
      prevProps.isLarge !== isLarge
    );
  }

  render() {
    const { isLarge, backgroundImage, backgroundPosition, children } = this.props;
    const style = { backgroundImage: `url(${backgroundImage})`, backgroundPosition };
    return (
      <div className={`estate-image${isLarge ? `` : ` shrinked`}`} style={style}>
        {children}
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/presentational/Header/index.js